import { render } from "./SlidesCate.vue?vue&type=template&id=2ffff552&scoped=true"
import script from "./SlidesCate.vue?vue&type=script&lang=js"
export * from "./SlidesCate.vue?vue&type=script&lang=js"

import "./SlidesCate.vue?vue&type=style&index=0&id=2ffff552&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffff552"]])

export default __exports__